// Client data access for the AI blog. Anon RLS exposes only published posts.
import { supabase } from "./supabaseClient";

const SELECT = "id,group_id,locale,category,slug,title,description,body,tags,cover_url,published_at";

// Map the app locale (zh-HK / en / ja) to a blog locale. Blog is generated in
// zh-HK + en only; ja/others fall back to English.
export function blogLocaleFor(appLocale) {
  return appLocale === "zh-HK" ? "zh-HK" : "en";
}

export async function fetchBlogPosts({ locale = "zh-HK", category = null, limit = 30 } = {}) {
  let q = supabase.from("blog_posts").select(SELECT)
    .eq("status", "published").eq("locale", locale)
    .order("published_at", { ascending: false }).limit(limit);
  if (category) q = q.eq("category", category);
  const { data, error } = await q;
  if (error) throw error;
  return data || [];
}

export async function fetchBlogPost(slug) {
  const { data, error } = await supabase.from("blog_posts").select(SELECT)
    .eq("slug", slug).eq("status", "published").maybeSingle();
  if (error) throw error;
  return data || null;
}

// Sibling post in the other language (for the language switcher on an article).
export async function fetchBlogAlternate(groupId, otherLocale) {
  if (!groupId) return null;
  const { data } = await supabase.from("blog_posts").select("slug,locale")
    .eq("group_id", groupId).eq("locale", otherLocale).eq("status", "published").maybeSingle();
  return data || null;
}

// Related posts by shared tags (same locale), excluding the current post.
export async function fetchRelatedPosts({ tags = [], excludeId, locale = "zh-HK", limit = 4 }) {
  if (!tags.length) return [];
  const { data, error } = await supabase.from("blog_posts")
    .select("slug,title,description,cover_url,category")
    .eq("status", "published").eq("locale", locale)
    .overlaps("tags", tags).neq("id", excludeId)
    .order("published_at", { ascending: false }).limit(limit);
  if (error) return [];
  return data || [];
}

export const BLOG_CATEGORIES = {
  "grooming-knowledge": { zh: "美容知識", en: "Grooming Knowledge" },
  "grooming-skills":    { zh: "美容技巧", en: "Grooming Skills" },
  "hair-styling":       { zh: "造型設計", en: "Hair Styling" },
  "dog-behaviour":      { zh: "狗狗行為", en: "Dog Behaviour" },
  "pet-safety":         { zh: "安全與風險", en: "Safety & Risk" },
  "hiring":             { zh: "招聘面試", en: "Hiring" },
  "staff-management":   { zh: "員工管理", en: "Staff Management" },
  "shop-management":    { zh: "店舖營運", en: "Shop Management" },
  "open-salon":         { zh: "開店指南", en: "Open a Salon" },
  "marketing":          { zh: "營銷推廣", en: "Marketing" },
  "industry-trends":    { zh: "行業趨勢", en: "Industry Trends" },
};
